export const FEATURE_NAME = '@vshosting/cdn/core/domain-base';

export const DOMAIN_STATUS_COLOR_MAP = {
  ACTIVE: '#66BB6A',
  DISABLED: '#FFA726',
  SUSPENDED_ACTIVE: '#C8E6C9',
  SUSPENDED_DISABLED: '#FFE0B2',
  DELETED: '#EF5350'
}
